import { ANO_CALENDARIO } from '../../../../../config/anoLetivo';
import CalendarioImagens from '../../../../../componentes/js/CalendarioImagens';

const CalendarioSection = () => (
  <section className="calendario">
    <div style={{display: 'flex', flexDirection: 'row', textAlign: 'center', alignItems: 'center', gap: '15px'}}>
      <h2 className='titulo-secao'>Calendário {ANO_CALENDARIO}</h2>
      <p><a href='/materiais' style={{color: '#333'}}>Procurando a lista de materiais? <span style={{textDecoration: 'underline'}}>Clique aqui!</span></a></p>
    </div>
    <CalendarioImagens segmento='Ensino Fundamental II' paginas={['fund2a.png', 'fund2b.png']} />
  </section>
);

export default CalendarioSection;
